import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  vid: {
    width: '100%',
    boxShadow: '3px 3px 7px gray'
  }
});
